import type { ReactNode } from "react";

export function Banner({ kind, children }: { kind: "error" | "ok" | "warn"; children: ReactNode }) {
  return (
    <div className={`banner ${kind}`} role={kind === "error" ? "alert" : "status"}>
      {children}
    </div>
  );
}

export function Empty({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="empty">
      <p style={{ fontWeight: 500, color: "var(--text)" }}>{title}</p>
      {children ? <p style={{ marginTop: 6 }}>{children}</p> : null}
    </div>
  );
}

export function Loading({ label = "Loading" }: { label?: string }) {
  return (
    <p className="muted" style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <span className="spinner" aria-hidden="true" /> {label}
    </p>
  );
}

export function Field({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <div className="field">
      <label>{label}</label>
      {children}
      {hint ? <p className="field-hint">{hint}</p> : null}
    </div>
  );
}

export function StatusPill({ status }: { status: string }) {
  const kind = status === "ok" ? "ok" : status === "error" ? "error" : "";
  const label = status === "ok" ? "Key works" : status === "error" ? "Key failed" : "Not tested";
  return <span className={`pill ${kind}`}>{label}</span>;
}

/** Unix seconds to a short local date, or a dash when never. */
export function formatDate(unixSeconds: number | null | undefined): string {
  if (!unixSeconds) return "—";
  return new Date(unixSeconds * 1000).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
